<template>
  <div class="hongbao" style="opacity: 1;">
    <iframe ref="iframeId" id="iframeId" style="height: 100vh;width: 375px;" frameborder="0" allowtransparency="true"
      :src="mSrc"></iframe>
  </div>
</template>

<script>
import { c, openNavUrl } from '@/utils'
export default {
  name: 'hongbao',
  data () {
    return {
      mSrc: ''
    }
  },
  mounted () {
    let __token = c.getCookie('InsBackUserToken_V3')

    let test = location.host.split('.')[0] + '.'
    this.mSrc = location.protocol + '//' + (process.env.NODE_ENV === 'production' ? '' : test) + process.env.H5_URL + '/v301/activities?source=2&token=' + __token
    // this.mSrc = 'http://192.168.10.134:8080/v301/activities?source=2&token=' + __token

    var iframeDoc = window.frames['iframeId']
    iframeDoc.onload = () => {
      if (iframeDoc && iframeDoc.contentWindow) {
        iframeDoc.contentWindow.postMessage('openHbFromPc', '*')
      }
      // try {
      //   var doc = iframeDoc.contentWindow.document
      //   doc.body.style.backgroundColor = 'transparent'
      //   doc.getElementsByClassName('index')[0].style.backgroundColor = 'transparent'
      // } catch (e) {}
    }
    window.addEventListener('message', this.receiveMessage, false)
  },
  methods: {
    receiveMessage (event) {
      let data = event.data
      if (data === 'mClose') {
        this.$emit('close', false)
      } else if (data === 'quote') {
        let isProduction = process.env.NODE_ENV === 'production'
        let test = location.host.split('.')[0] + '.'
        let host = `http://${isProduction ? '' : test}cxv3.youbaolian.top/`
        let url = `http://${isProduction ? '' : test}new-quote.youbaolian.top/insure/`
        openNavUrl(url, '报价录单', host, 'self', true, 0, 'n10001')
        this.$emit('close', false)
      } else if (data === 'actEvent') {
        this.$emit('actEvent')
      }
    }
  },
  destroyed () {
    window.removeEventListener('message', this.receiveMessage)
  }
}
</script>

<style lang="less" scoped>
.hongbao {
  position: fixed;
  text-align: center;
  left: 0;
  top: 0;
  width: 100%;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.6);
  z-index: 99999;
}
</style>



// WEBPACK FOOTER //
// src/views/activities/HongBao.vue